import {Component, Input, ElementRef, Renderer2} from "@angular/core";
import {ToggleButtonComponent} from "./toggle.button.component";

@Component({
    selector: 'toggle-item',
    host: {
        '(click)': 'selectItem()'
    },
    template: require('./toggle.item.template.html')
})
export class ToggleItemComponent {

    @Input('value') value: string;

    private isActivated: boolean = false;

    constructor(private rootComponent: ToggleButtonComponent,
                private el: ElementRef,
                private renderer: Renderer2) {
    }

    ngOnInit() {
        this.rootComponent.registerChild(this);
    }

    ngAfterContentInit() {
        this.setupStyles();
        this.updateView();
    }

    public selectItem() {
        if(!this.rootComponent.disabled) {
            this.rootComponent.selectItem(this);
        }
    }

    public activateItem() {
        this.isActivated = true;
        this.updateView();
    }

    public deactivateItem() {
        this.isActivated = false;
        this.updateView();
    }

    public setWidth(width: string) {
        this.renderer.setStyle(this.el.nativeElement, 'width', width);
    }

    public updateView() {
        this.setClass('disabled', this.rootComponent.disabled);
        this.setClass('open', this.isActivated);
        this.setClass('btn-primary', this.isActivated);
        this.setClass('btn-default', !this.isActivated);
    }

    public getIsActivated() {
        return this.isActivated;
    }

    private setupStyles() {
        this.renderer.addClass(this.el.nativeElement, 'btn');
    }

    private setClass(className : string, add : boolean) {
        if (!!add) {
            this.renderer.addClass(this.el.nativeElement, className);
        } else {
            this.renderer.removeClass(this.el.nativeElement, className);
        }

    }

    public getValue() {
        return this.value;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/toggle/toggle.item.component.ts